// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"82":"06c93689","611":"06c93689","923":"06c93689","995":"12c4c2e4"}[chunkId] + ".chunk.css";
};